<template>
  <div class="row">
    <div class="col-12">
      <h5 data-cy="application-form-section-documents">
        {{ $t('message.applicationForm.documents') }}
      </h5>
    </div>
    <div class="col-12 col-md-6">
      <div>
        <div class="d-inline-block">
          <b>{{ $t('message.applicationForm.debtEnforcementRegister') }}</b><br>
          <span class="maxFileSize">max. 50MB</span>
        </div>
        <coozzy-button
          class="float-right"
          data-cy="application-form-company-upload-debt-register-button"
          design="green"
          @click="uploadDocumentClicked('debtUpload')">
          {{ $t('message.manageDocuments.addDocument') }}
        </coozzy-button>
      </div>
      <coozzy-spinner
        v-if="debtUploadProcessing"
        class="align-self-center" />
      <div
        v-for="item in debtEnforcementRegisterMedia"
        :key="item.id"
        class="media-block col">
        <div
          class="file-block p-1 my-2">
          <a
            :href="item.url"
            data-v-09485260=""
            target="_blank">
            {{ item.filename }}
          </a>
          <coozzy-button
            class="delete-icon"
            design="transparent"
            @click="deleteMedia(item.id, 'debtEnforcementRegisterMediaIds')">
            <coozzy-delete-icon />
          </coozzy-button>
        </div>
      </div>
      <coozzy-form-file-input
        ref="debtUpload"
        v-model="debtUpload"
        accept="text/plain, text/csv, application/pdf, image/*, video/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
        class="d-none"
        @change="addFile($event, 'debtEnforcementRegisterMediaIds')" />
    </div>
    <div class="col-12 col-md-6">
      <div>
        <div class="d-inline-block">
          <b>{{ $t('message.applicationForm.tradeRegisterExcerptMedia') }}</b><br>
          <span class="maxFileSize">max. 50MB</span>
        </div>
        <coozzy-button
          class="float-right"
          data-cy="application-form-company-upload-trade-register-button"
          design="green"
          @click="uploadDocumentClicked('tradeRegisterExcerptUpload')">
          {{ $t('message.manageDocuments.addDocument') }}
        </coozzy-button>
      </div>
      <coozzy-spinner
        v-if="tradeRegisterExcerptProcessing"
        class="align-self-center" />
      <div
        v-for="item in tradeRegisterExcerptMedia"
        :key="item.id"
        class="media-block col">
        <div
          class="file-block p-1 my-2">
          <a
            :href="item.url"
            data-v-09485260=""
            target="_blank">
            {{ item.filename }}
          </a>
          <coozzy-button
            class="delete-icon"
            design="transparent"
            @click="deleteMedia(item.id, 'tradeRegisterExcerptMediaIds')">
            <coozzy-delete-icon />
          </coozzy-button>
        </div>
      </div>
      <coozzy-form-file-input
        ref="tradeRegisterExcerptUpload"
        v-model="tradeRegisterExcerptUpload"
        accept="text/plain, text/csv, application/pdf, image/*, video/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
        class="d-none"
        @change="addFile($event, 'tradeRegisterExcerptMediaIds')" />
    </div>
    <div class="col-12 col-md-6 mt-2">
      <div>
        <div class="d-inline-block">
          <b>{{ $t('message.applicationForm.idCard') }}</b><br>
          <span class="maxFileSize">max. 50MB</span>
        </div>
        <coozzy-button
          class="float-right"
          data-cy="application-form-company-upload-id-card-button"
          design="green"
          @click="uploadDocumentClicked('idCardUpload')">
          {{ $t('message.manageDocuments.addDocument') }}
        </coozzy-button>
      </div>
      <coozzy-spinner
        v-if="idCardUploadProcessing"
        class="align-self-center" />
      <div
        v-for="item in idCardMedia"
        :key="item.id"
        class="media-block col">
        <div
          class="file-block p-1 my-2">
          <a
            :href="item.url"
            data-v-09485260=""
            target="_blank">
            {{ item.filename }}
          </a>
          <coozzy-button
            class="delete-icon"
            design="transparent"
            @click="deleteMedia(item.id, 'idCardMedia')">
            <coozzy-delete-icon />
          </coozzy-button>
        </div>
      </div>
      <coozzy-form-file-input
        ref="idCardUpload"
        v-model="idCardUpload"
        accept="text/plain, text/csv, application/pdf, image/*, video/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
        class="d-none"
        @change="addFile($event, 'idCardMediaIds')" />
    </div>
    <div class="col-12 col-md-6 mt-2">
      <div>
        <div class="d-inline-block">
          <b>{{ $t('message.applicationForm.media') }}</b><br>
          <span class="maxFileSize">max. 50MB</span>
        </div>
        <coozzy-button
          class="float-right"
          data-cy="application-form-company-upload-additional-documents-button"
          design="green"
          @click="uploadDocumentClicked('mediaUpload')">
          {{ $t('message.manageDocuments.addDocument') }}
        </coozzy-button>
      </div>
      <coozzy-spinner
        v-if="mediaUploadProcessing"
        class="align-self-center" />
      <div
        v-for="item in media"
        :key="item.id"
        class="media-block col">
        <div
          class="file-block p-1 my-2">
          <a
            :href="item.url"
            data-v-09485260=""
            target="_blank">
            {{ item.filename }}
          </a>
          <coozzy-button
            class="delete-icon"
            design="transparent"
            @click="deleteMedia(item.id, 'mediaIds')">
            <coozzy-delete-icon />
          </coozzy-button>
        </div>
      </div>
      <coozzy-form-file-input
        ref="mediaUpload"
        v-model="mediaUpload"
        accept="text/plain, text/csv, application/pdf, image/*, video/*, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
        class="d-none"
        @change="addFile($event, 'mediaIds')" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import { mapMutations } from 'vuex'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import { media } from '@/mixins/media'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import CoozzyDeleteIcon from '@/framework/components/icons/CoozzyDeleteIcon.vue'
import CoozzyFormFileInput from '@/framework/components/form/fileInput/CoozzyFormFileInput.vue'
import { ApplicationFormCompany, ApplicationFormDocumentMediaRow } from '@/types/models'

type CompanyMediaIdField =
  | 'debtEnforcementRegisterMediaIds'
  | 'idCardMediaIds'
  | 'mediaIds'
  | 'tradeRegisterExcerptMediaIds'

interface CompanyDocumentsData {
  debtEnforcementRegisterMedia: ApplicationFormDocumentMediaRow[]
  idCardMedia: ApplicationFormDocumentMediaRow[]
  tradeRegisterExcerptMedia: ApplicationFormDocumentMediaRow[]
  media: ApplicationFormDocumentMediaRow[]
  mediaUpload: File | null
  mediaUploadProcessing: boolean
  tradeRegisterExcerptUpload: File | null
  tradeRegisterExcerptProcessing: boolean
  idCardUpload: File | null
  idCardUploadProcessing: boolean
  debtUpload: File | null
  debtUploadProcessing: boolean
}

export default Vue.extend({
  name: 'ApplicationFormCompanyDocuments',
  components: {
    CoozzyFormFileInput,
    CoozzyDeleteIcon,
    CoozzyButton,
    CoozzySpinner
  },
  mixins: [media],
  props: {
    company: {
      type: Object as PropType<ApplicationFormCompany | null>,
      default: null
    }
  },
  data(): CompanyDocumentsData {
    return {
      debtEnforcementRegisterMedia: [],
      idCardMedia: [],
      tradeRegisterExcerptMedia: [],
      media: [],
      mediaUpload: null,
      mediaUploadProcessing: false,
      tradeRegisterExcerptUpload: null,
      tradeRegisterExcerptProcessing: false,
      idCardUpload: null,
      idCardUploadProcessing: false,
      debtUpload: null,
      debtUploadProcessing: false
    }
  },
  computed: {
    debtEnforcementRegisterMediaIds: {
      get(): string[] {
        if (!this.company) return []
        return this.company.debtEnforcementRegisterMediaIds
          ? this.company.debtEnforcementRegisterMediaIds
          : []
      },
      set(value: string[]) {
        const com = this.company
        if (!com) return
        com.debtEnforcementRegisterMediaIds = value
        this.updateCompany(com)
      }
    },
    idCardMediaIds: {
      get(): string[] {
        if (!this.company) return []
        return this.company.idCardMediaIds ? this.company.idCardMediaIds : []
      },
      set(value: string[]) {
        const com = this.company
        if (!com) return
        com.idCardMediaIds = value
        this.updateCompany(com)
      }
    },
    tradeRegisterExcerptMediaIds: {
      get(): string[] {
        if (!this.company) return []
        return this.company.tradeRegisterExcerptMediaIds
          ? this.company.tradeRegisterExcerptMediaIds
          : []
      },
      set(value: string[]) {
        const com = this.company
        if (!com) return
        com.tradeRegisterExcerptMediaIds = value
        this.updateCompany(com)
      }
    },
    mediaIds: {
      get(): string[] {
        if (!this.company) return []
        return this.company.mediaIds ? this.company.mediaIds : []
      },
      set(value: string[]) {
        const com = this.company
        if (!com) return
        com.mediaIds = value
        this.updateCompany(com)
      }
    }
  },
  methods: {
    ...mapMutations('applicationForm', ['updateCompany']),
    uploadDocumentClicked(ref: string) {
      if (!this.readOnly) {
        const comp = this.$refs[ref] as Vue & { $el: HTMLElement }
        const btn = comp.$el.children
        ;(btn[0] as HTMLElement).click()
      }
    },
    async addFile(event: Event, source: CompanyMediaIdField) {
      if (source === 'debtEnforcementRegisterMediaIds') {
        this.debtUploadProcessing = true
      } else if (source === 'idCardMediaIds') {
        this.idCardUploadProcessing = true
      } else if (source === 'mediaIds') {
        this.mediaUploadProcessing = true
      } else if (source === 'tradeRegisterExcerptMediaIds') {
        this.tradeRegisterExcerptProcessing = true
      }
      const files = await this.getFilesFromEvent(event)
      if (files && files.length > 0) {
        const file = files[0] as File
        await this.documentCreated(file, source)
      }
      if (source === 'debtEnforcementRegisterMediaIds') {
        this.debtUploadProcessing = false
      } else if (source === 'idCardMediaIds') {
        this.idCardUploadProcessing = false
      } else if (source === 'mediaIds') {
        this.mediaUploadProcessing = false
      } else if (source === 'tradeRegisterExcerptMediaIds') {
        this.tradeRegisterExcerptProcessing = false
      }
    },
    async documentCreated(document: File, suffix: CompanyMediaIdField) {
      const docSizeMB = document.size / (1024 * 1024)
      if (docSizeMB > 50) {
        this.mediaUploadProcessing = false
        this.debtUploadProcessing = false
        this.idCardUploadProcessing = false
        this.tradeRegisterExcerptProcessing = false
        Vue.toasted.show(this.$tc('message.uploadingErrors.maxFileSize'), { type: 'error' })
      } else {
        const selectedFile = [document]
        const response = await this.uploadMedia(selectedFile)
        if (response && response.length > 0) {
          const uploaded = response[0]
          const mediaRow: ApplicationFormDocumentMediaRow = {
            id: uploaded.id,
            url: uploaded.url,
            filename: uploaded.filename
          }
          if (suffix === 'debtEnforcementRegisterMediaIds') {
            this.debtEnforcementRegisterMediaIds = [
              ...this.debtEnforcementRegisterMediaIds,
              uploaded.id
            ]
            this.debtEnforcementRegisterMedia.push(mediaRow)
          } else if (suffix === 'idCardMediaIds') {
            this.idCardMediaIds = [...this.idCardMediaIds, uploaded.id]
            this.idCardMedia.push(mediaRow)
          } else if (suffix === 'tradeRegisterExcerptMediaIds') {
            this.tradeRegisterExcerptMediaIds = [
              ...this.tradeRegisterExcerptMediaIds,
              uploaded.id
            ]
            this.tradeRegisterExcerptMedia.push(mediaRow)
          } else {
            this.mediaIds = [...this.mediaIds, uploaded.id]
            this.media.push(mediaRow)
          }
          this.mediaUpload = null
          this.debtUpload = null
          this.tradeRegisterExcerptUpload = null
          this.idCardUpload = null
        }
        this.mediaUploadProcessing = false
        this.debtUploadProcessing = false
        this.idCardUploadProcessing = false
        this.tradeRegisterExcerptProcessing = false
      }
    },
    deleteMedia(id: string, suffix: CompanyMediaIdField | 'idCardMedia' | 'tradeRegisterExcerptMedia') {
      const idSuffix =
        suffix === 'idCardMedia'
          ? 'idCardMediaIds'
          : suffix === 'tradeRegisterExcerptMedia'
            ? 'tradeRegisterExcerptMediaIds'
            : suffix
      const idList = this[idSuffix] as string[]
      this[idSuffix] = idList.filter(e => e !== id)
      const listKey = idSuffix.replace(/Ids$/, '') as
        | 'debtEnforcementRegisterMedia'
        | 'idCardMedia'
        | 'tradeRegisterExcerptMedia'
        | 'media'
      const list = this[listKey] as ApplicationFormDocumentMediaRow[]
      this[listKey] = list.filter(el => el.id !== id)
    }
  }
})
</script>

<style lang="scss" scoped>
.maxFileSize {
  font-size: 0.875rem;
}
</style>
